import { Alert, Button } from '@backstage/ui';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { useSignOut } from '../projectsNav/useSignOut';
import { projectEnvironmentsTranslationRef } from './translation';

/**
 * « Reconnexion nécessaire »: what the environments card and the branch page
 * show instead of « nothing here » when the id_token carries none of the
 * project's groups (`useStaleProjectAccess`). The button signs out exactly as
 * the sidebar does — Backstage, then Authelia — so the next sign-in issues a
 * token with the groups as they are now.
 */
export function ReauthAlert() {
  const { t } = useTranslationRef(projectEnvironmentsTranslationRef);
  const { signOut, pending } = useSignOut();

  return (
    <Alert
      status="info"
      icon
      title={t('reauth.title')}
      description={t('reauth.description')}
      customActions={
        <Button
          size="small"
          variant="primary"
          isPending={pending}
          // `signOut` reports its own failure, so nothing can reject.
          onPress={() => void signOut()}
        >
          {t('reauth.button')}
        </Button>
      }
    />
  );
}
